var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div class=\"dashboard container\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <h1 class=\"page-header\">Dashboard</h1>\n    </div>\n  </div>\n  <div class=\"row node-selection\">\n    <div class=\"col-lg-3\">\n      <div class=\"input-group\">\n        <input type=\"text\" placeholder=\"Server node\" class=\"form-control\"/>\n        <div class=\"input-group-addon\"><span class=\"fa fa-angle-double-right\"></span></div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row widgets\"></div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}